// trader_agent_frontend/src/config/version.js
const buildInfo = {
  version: process.env.REACT_APP_VERSION || '1.0.0',
  buildDate: process.env.REACT_APP_BUILD_DATE || new Date().toISOString(),
  commitHash: process.env.REACT_APP_COMMIT_HASH || 'dev-local',
  branch: process.env.REACT_APP_BRANCH || 'dev'
};

export default buildInfo;